import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Dreamzz HR & Consultancy";
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function Seo({ title, description, canonical, image, type = "website", schema, noindex }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Connecting Talent With Opportunity`;
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
  const desc = description || "Professional manpower recruitment, staffing and HR solutions across Karnataka for businesses and job seekers.";
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}

export function orgSchema(settings) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: settings?.company_name || SITE,
    url: BASE,
    email: settings?.email,
    telephone: settings?.phone,
    address: { "@type": "PostalAddress", addressLocality: "Chikkamagaluru", addressRegion: "Karnataka", addressCountry: "IN" },
    sameAs: [settings?.facebook, settings?.instagram, settings?.linkedin].filter(Boolean),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name, item: it.url,
    })),
  };
}
